// APIError class that extends Error interface implements the IErrorContract interface
export class APIError extends Error {
    constructor(code, message, error) {
        super(message); // Call the parent class (Error) constructor with the message
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // API error status code
        Object.defineProperty(this, "source", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'API'
        }); // Set the source to 'API'
        Object.defineProperty(this, "message", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.code = code;
        this.message = message;
        this.error = error;
    }
}
//# sourceMappingURL=APIError.js.map